/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

if (process.env.BOOTSTRAP_ENABLED) {
  angular.module('bulbApp.bootstrapModule', ['ui.router', 'bulbApp.authModule', 'bulbApp.configModule'])
    .config(['$stateProvider', 'AUTH', ($stateProvider, AUTH) => {
      $stateProvider
        .state('bootstrap', {
          parent: 'bulbView',
          url: '^/b/bootstrap',
          resolve: {
            // Inject every developer into the controller:
            devLogin: ['Restangular', (Restangular) => Restangular.one('bootstrap/dev_login').get()],
            title: () => 'Bootstrap',
          },
          views: {
            bulbView: {
              template: '<bootstrap-component dev-login="$resolve.devLogin" title="$resolve.title">'
                  + '</bootstrap-component>',
            },
          },
          bulbAuth: {
            authorizedRoles: [AUTH.ROLES.ADMIN],
            // This html will only show up on envs where bootstrap is enabled, so return true.
            isAuthorized: () => true,
          },
        });
    }]);
} else {
  angular.module('bulbApp.bootstrapModule', []);
}
